/* tslint:disable */
/* eslint-disable */
/**
 * REGUZA
 * Aspe licensing management tool
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PaymentStrategyEnum } from './PaymentStrategyEnum';
import {
    PaymentStrategyEnumFromJSON,
    PaymentStrategyEnumFromJSONTyped,
    PaymentStrategyEnumToJSON,
    PaymentStrategyEnumToJSONTyped,
} from './PaymentStrategyEnum';
import type { DiscountTypeEnum } from './DiscountTypeEnum';
import {
    DiscountTypeEnumFromJSON,
    DiscountTypeEnumFromJSONTyped,
    DiscountTypeEnumToJSON,
    DiscountTypeEnumToJSONTyped,
} from './DiscountTypeEnum';
import type { UpdateOfferProduct } from './UpdateOfferProduct';
import {
    UpdateOfferProductFromJSON,
    UpdateOfferProductFromJSONTyped,
    UpdateOfferProductToJSON,
    UpdateOfferProductToJSONTyped,
} from './UpdateOfferProduct';

/**
 * 
 * @export
 * @interface UpdateOfferProductsRequest
 */
export interface UpdateOfferProductsRequest {
    /**
     * 
     * @type {PaymentStrategyEnum}
     * @memberof UpdateOfferProductsRequest
     */
    paymentStrategy: PaymentStrategyEnum;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProductsRequest
     */
    paymentInterval: number;
    /**
     * 
     * @type {Date}
     * @memberof UpdateOfferProductsRequest
     */
    validTo: Date;
    /**
     * 
     * @type {Date}
     * @memberof UpdateOfferProductsRequest
     */
    contractValidFrom: Date;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProductsRequest
     */
    priceListId: number;
    /**
     * 
     * @type {number}
     * @memberof UpdateOfferProductsRequest
     */
    discount: number;
    /**
     * 
     * @type {DiscountTypeEnum}
     * @memberof UpdateOfferProductsRequest
     */
    discountType: DiscountTypeEnum;
    /**
     * 
     * @type {Array<UpdateOfferProduct>}
     * @memberof UpdateOfferProductsRequest
     */
    products: Array<UpdateOfferProduct>;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferProductsRequest
     */
    text: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateOfferProductsRequest
     */
    contractNumber: string;
}



/**
 * Check if a given object implements the UpdateOfferProductsRequest interface.
 */
export function instanceOfUpdateOfferProductsRequest(value: object): value is UpdateOfferProductsRequest {
    if (!('paymentStrategy' in value) || value['paymentStrategy'] === undefined) return false;
    if (!('paymentInterval' in value) || value['paymentInterval'] === undefined) return false;
    if (!('validTo' in value) || value['validTo'] === undefined) return false;
    if (!('contractValidFrom' in value) || value['contractValidFrom'] === undefined) return false;
    if (!('priceListId' in value) || value['priceListId'] === undefined) return false;
    if (!('discount' in value) || value['discount'] === undefined) return false;
    if (!('discountType' in value) || value['discountType'] === undefined) return false;
    if (!('products' in value) || value['products'] === undefined) return false;
    if (!('text' in value) || value['text'] === undefined) return false;
    if (!('contractNumber' in value) || value['contractNumber'] === undefined) return false;
    return true;
}

export function UpdateOfferProductsRequestFromJSON(json: any): UpdateOfferProductsRequest {
    return UpdateOfferProductsRequestFromJSONTyped(json, false);
}

export function UpdateOfferProductsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateOfferProductsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'paymentStrategy': PaymentStrategyEnumFromJSON(json['paymentStrategy']),
        'paymentInterval': json['paymentInterval'],
        'validTo': (new Date(json['validTo'])),
        'contractValidFrom': (new Date(json['contractValidFrom'])),
        'priceListId': json['priceListId'],
        'discount': json['discount'],
        'discountType': DiscountTypeEnumFromJSON(json['discountType']),
        'products': ((json['products'] as Array<any>).map(UpdateOfferProductFromJSON)),
        'text': json['text'],
        'contractNumber': json['contractNumber'],
    };
}

export function UpdateOfferProductsRequestToJSON(json: any): UpdateOfferProductsRequest {
    return UpdateOfferProductsRequestToJSONTyped(json, false);
}

export function UpdateOfferProductsRequestToJSONTyped(value?: UpdateOfferProductsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paymentStrategy': PaymentStrategyEnumToJSON(value['paymentStrategy']),
        'paymentInterval': value['paymentInterval'],
        'validTo': ((value['validTo']).toISOString()),
        'contractValidFrom': ((value['contractValidFrom']).toISOString()),
        'priceListId': value['priceListId'],
        'discount': value['discount'],
        'discountType': DiscountTypeEnumToJSON(value['discountType']),
        'products': ((value['products'] as Array<any>).map(UpdateOfferProductToJSON)),
        'text': value['text'],
        'contractNumber': value['contractNumber'],
    };
}

